import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Chart } from 'primereact/chart';

import { BookAppointmentTabs } from './BookAppointmentTabs';
import { getDateFilteredDetails, getSpecificItemDetails, postAllData } from '../../service/ProductService';
import { bookAppointmentApplication, bookAppointmentGraphApplication, convertDateFrom, customeDateOptions, paginatorLinks, showingEntries, SkeletonbodyTemplate, Skeletonitems } from '../../appconfig/Settings';
import { APPOINTMENTLIST, DOWNLOAD_APPOINTMENT_LIST, GRAPH_APPOINTMENTLIST } from '../../config/ApiConstant';
import { exportData, formatYearMonthDate, getApplicationValue } from '../../appconfig/AppHelper';
import { format } from 'date-fns';
import { AppointmentListColumns } from '../../appconfig/DatatableSetting';
import Loader from '../../components/Loadeer/Loader';
import { dateTemplate } from '../../appconfig/DatatableTemplateSetting';

export const AppointmentList = () => {
    document.title = 'Appointment List | GSPC';

    const navigate = useNavigate();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [appointmentList, setAppointmentList] = useState<any>([]);
    const [appType, setAppType] = useState<any>(bookAppointmentApplication[0]);

    // Date Object

    const [date, setDates] = useState<string | Date | Date[] | any | null>(new Date());

    //Application Chart Data

    const [allApplicationData, setAllApplicationData] = useState<any>();
    const [totalApplicationData, setTotalApplicationData] = useState<any>({});
    const [totalApplicationOptions, setTotalApplicationOptions] = useState<any>({});

    //chart selectiom
    const [selectedRange, setSelectedRange] = useState<any>(customeDateOptions[0]);
    const [showDropdown, setShowDropdown] = useState<boolean>(false);
    const [selectedApplicatiom, setSelectApplication] = useState<any>(bookAppointmentGraphApplication[0]);

    // useEffect
    useEffect(() => {
        getAllAppointmentList();
    }, [date, appType]);

    useEffect(() => {
        getAllAppointmentGraphList();
    }, [selectedRange, selectedApplicatiom]);

    useEffect(() => {
        getAllApplicationData();
    }, [allApplicationData]);

    // Get all appointment list
    const getAllAppointmentGraphList = async () => {
        try {
            setLoading(true);
            const response = await getDateFilteredDetails(
                GRAPH_APPOINTMENTLIST,
                'start_date',
                !window.cn(selectedRange) && convertDateFrom(selectedRange.from) + ' 00:00:00',
                'end_date',
                !window.cn(selectedRange) && convertDateFrom(selectedRange.to) + ' 23:59:59',
                'app_type',
                selectedApplicatiom?.code
            );

            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setAllApplicationData([]);
                } else {
                    setAllApplicationData(DataList);
                }
                setLoading(false);
            } else {
                setLoading(false);
                setAllApplicationData([]);
            }
        } catch (error: any) {
            setLoading(false);
            setAllApplicationData([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Alert',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const getAllApplicationData = () => {
        let labelsVal: any = '';
        let totalSlotsVal: any = '';
        let bookedVal: any = '';
        let availableVal: any = '';
        let maxVal: any = '';

        if (!window.cn(allApplicationData) && allApplicationData) {
            labelsVal = allApplicationData.length > 0 && allApplicationData.map((item: any) => item?.date);
            totalSlotsVal = allApplicationData.length > 0 && allApplicationData.map((item: any) => item?.total);
            bookedVal = allApplicationData.length > 0 && allApplicationData.map((item: any) => item?.booking);
            availableVal = allApplicationData.length > 0 && allApplicationData.map((item: any) => item?.available);

            if (!window.cn(totalSlotsVal) && totalSlotsVal.length > 0) {
                maxVal = Math.max(...totalSlotsVal);
            }
        }

        const data = {
            labels: labelsVal,
            datasets: [
                {
                    label: 'Total Slots',
                    data: totalSlotsVal,
                    borderColor: '#3b82f6',
                    backgroundColor: '#3b82f6',
                    barPercentage: 0.7
                },

                {
                    label: 'Booked Slots',
                    data: bookedVal,
                    borderColor: '#FC6161',
                    backgroundColor: '#FC6161',
                    barPercentage: 0.7
                },
                {
                    label: 'Vacant Slots',
                    data: availableVal,
                    borderColor: '#0BD18A',
                    backgroundColor: '#0BD18A',
                    barPercentage: 0.7
                }
            ]
        };

        const options = {
            maintainAspectRatio: false,
            aspectRatio: 1,

            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        boxWidth: 40
                    }
                }
            },
            hover: {
                mode: 'index'
            },
            scales: {
                y: {
                    min: 0,
                    max: maxVal < 50 ? 50 : maxVal + 20,
                    ticks: {
                        stepSize: 10
                    }
                }
            }
        };

        setTotalApplicationData(data);
        setTotalApplicationOptions(options);
    };

    // Get all appointment list
    const getAllAppointmentList = async () => {
        try {
            setPageLoad(true);
            const response = await getSpecificItemDetails(APPOINTMENTLIST, 'date', formatYearMonthDate(date), 'app_id', appType?.code);

            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setAppointmentList([]);
                } else {
                    setAppointmentList(DataList);
                }
                setPageLoad(false);
            } else {
                setPageLoad(false);
                setAppointmentList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setAppointmentList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // On Date Change
    const onDateChange = (e: any) => {
        setDates(e.value);
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <Calendar value={date} dateFormat="dd/mm/yy" onChange={(e) => onDateChange(e)} showIcon className="mr-2" />
                <Dropdown value={appType} onChange={(e: any) => setAppType(e.value)} options={bookAppointmentApplication} optionLabel="name" placeholder="Select Application type"></Dropdown>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button label="Export" icon="pi pi-file-export" onClick={() => exportCSV()} />
            </>
        );
    };

    // Export csv
    const exportCSV = () => {
        exportData('Appointment_List');
    };

    // Search by app
    const searchByApp = (options: any) => {
        return (
            <Dropdown
                filter
                value={appType}
                onChange={(e: any) => {
                    setAppType(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={bookAppointmentApplication}
                optionLabel="name"
                placeholder="Search By Application"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Template for application
    const applicationTemplate = (rowData: any) => {
        return <>{getApplicationValue(rowData.app_id)}</>;
    };

    // Template for appointment time
    const appointmentTimeTemplate = (rowData: any) => {
        return <>{rowData.slot_start_time + ' - ' + rowData.slot_end_time}</>;
    };

    // Download data
    const downloadData = async (id: any) => {
        try {
            setLoading(true);
            let formData: any = new FormData();
            formData.append('slot_id', id);

            //apicall
            const response = await postAllData(DOWNLOAD_APPOINTMENT_LIST, formData);
            if (response && !window.cn(response)) {
                const file_url = response.data;

                //PDF Download
                const fileName = `AppointmentList${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setLoading(false);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Something went wrong'
            });
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="View" tooltipOptions={{ position: 'top' }} icon="pi pi-eye" onClick={() => navigate('/app/user-appointment-list/' + btoa(rowData.id))} />
                    <Button tooltip="Download" tooltipOptions={{ position: 'top' }} icon="pi pi-download" onClick={() => downloadData(rowData.id)} className="ml-2" disabled={rowData.booked_members == '0' ? true : false} />
                </div>
            </>
        );
    };

    return (
        <>
            <BookAppointmentTabs mainTabLabel="Appointment List" />

            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card widget-revenue-graph">
                        <div className="card-header mb-2">
                            <span className="overview-text-h">Appointment</span>
                            <div className="flex">
                                <Dropdown
                                    value={selectedApplicatiom}
                                    onChange={(e: any) => setSelectApplication(e.value)}
                                    options={bookAppointmentGraphApplication}
                                    optionLabel="name"
                                    className="graph-drp"
                                    placeholder="Select Application type"
                                ></Dropdown>
                                <div className="relative ml-4">
                                    {/* Button to Open Dropdown */}
                                    <button onClick={() => setShowDropdown(!showDropdown)} className="custom-datepicker">
                                        {format(selectedRange.from, 'MMM dd, yyyy')} - {format(selectedRange.to, 'MMM dd, yyyy')}
                                    </button>

                                    {/* Dropdown Menu */}
                                    {showDropdown && (
                                        <div className="absolute mt-2 w-80 bg-white shadow-lg border rounded-md selected-option-btn">
                                            {customeDateOptions.map((preset, index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => {
                                                        setSelectedRange(preset);
                                                        setShowDropdown(false);
                                                    }}
                                                    className="block w-full text-left"
                                                >
                                                    {preset.label} ({format(preset.from, 'MMM dd')} - {format(preset.to, 'MMM dd')})
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="graph">
                            <Chart type="bar" id="revenue-chart" data={totalApplicationData} options={totalApplicationOptions}></Chart>
                        </div>
                        {loading && <Loader />}
                    </div>

                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {!pageLoad ? (
                            <>
                                <DataTable
                                    value={appointmentList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Appointments Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {AppointmentListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'appointment_time') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={appointmentTimeTemplate} />;
                                        } else if (col.field === 'app_id') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationTemplate} filter filterElement={searchByApp} />;
                                        } else if (col.field === 'date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AppointmentListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
